// Función para detectar si el navegador está en modo incógnito
export const detectIncognito = () => {
  return new Promise((resolve) => {
    const fs = window.RequestFileSystem || window.webkitRequestFileSystem;
    
    if (!fs) {
      // Si no hay API de FileSystem, asumir modo normal
      resolve(false);
    } else {
      // Intentar crear un archivo temporal
      fs(window.TEMPORARY, 100, () => resolve(false), () => resolve(true));
    }
  });
};

// Función alternativa más moderna
export const isIncognitoMode = async () => {
  // Para Chrome/Edge
  if ('storage' in navigator && 'estimate' in navigator.storage) {
    const {usage, quota} = await navigator.storage.estimate();
    if (quota < 120000000) {
      return true; // Probablemente incógnito
    }
  }
  
  // Para Safari
  try {
    const test = window.openDatabase(null, null, null, null);
    return false;
  } catch (e) {
    return true;
  }
};

// Mostrar advertencia si está en modo incógnito
export const checkAndWarnIncognito = async () => {
  const isIncognito = await isIncognitoMode();
  
  if (isIncognito) {
    console.warn('⚠️ Modo incógnito detectado - Los pagos pueden no funcionar correctamente');
    return true;
  }
  
  return false;
};